import { Icon } from '@chakra-ui/react';

export default function GaugeStrategic({ ...props }) {
  return (
    <Icon
      width='14px'
      height='14px'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.9598 10.9597C13.1467 8.77278 13.1467 5.22706 10.9598 3.04012C8.77286 0.853184 5.22714 0.853184 3.0402 3.04012C0.853266 5.22706 0.853266 8.77278 3.0402 10.9597'
        stroke='#1353EC'
        strokeWidth='2'
      />
      <path
        d='M13.6682 3.14998C14.0548 3.81959 8.36945 7.82582 7.69984 8.21242C7.03023 8.59902 6.174 8.36959 5.7874 7.69998C5.4008 7.03037 5.63023 6.17415 6.29984 5.78755C6.96945 5.40095 13.2816 2.48037 13.6682 3.14998Z'
        fill='#123790'
      />
    </Icon>
  );
}
